import { useEffect, useState } from "react";
import { MaxYieldData } from "types/common";

// Services
import { getMaxDefiYield } from "services/app";

const useMaxDefiStrategy = () => {
  const [data, setData] = useState({} as MaxYieldData);

  useEffect(() => {
    (async function fetchData() {
      const response = await getMaxDefiYield();

      setData(response);
    })();
  }, []);

  return data;
};

export default useMaxDefiStrategy;
